<template>
    <span class="js-coupon-button"
       data-t="8.5"
       :data-coupon-id="model.id"
       :data-coupon-url="url"
       :data-product-id="productId">
        <slot />
    </span>
</template>
<script>
    const TYPES = [
        'default',
        'big'
    ];

    export default {
        name: 'dm-product-coupon',
        props: {
            url: {
                type: String,
                required: true
            },
            model: {
                type: Object,
                required: true
            },
            productId: {
                type: Number,
                required: true
            },
            type: {
                type: String,
                default: TYPES[0],
                validator: value => TYPES.includes(value)
            }
        }
    };
</script>
